import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface SendOtcResponse extends BackendResponse {
  /** The actual one-time code. Only populated when the request originates from
   *  a local IP (VPN). Used by the VPN-only "insert code" helper in the
   *  verification dialog so developers don't have to fish the code out of email. */
  vpnCode?: string | null;
}

export interface SendOtcParameters extends NextApiParams {
  email: string;
  concernId: number;
  evaluatedLocale: string;
}

export const sendOtc = withNextApi<SendOtcResponse, SendOtcParameters>(
  "/auth/SendOtc"
);
